import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c71c731"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c71c731')) {
      api.createRecord('3c71c731', component.options)
    } else {
      api.reload('3c71c731', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c71c731", function () {
      api.rerender('3c71c731', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/a-back-top/index.vue"
export default component.exports